import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { getDeviceDetail, putDeviceDetail, getDevicegroupsTree, deviceSwitch } from '@blade-sxp/pass/api/access-management/device-management';
import AuthItem from '@blade/common/components/auth/auth-item.vue';
let default_1 = class extends Vue {
    input = '';
    groupIdvalue = '';
    groupTree = [];
    currIndex = 0;
    parentId = 0;
    groupId = '';
    canWrite = true;
    detailList = {};
    deviceName = '';
    position = '';
    deviceError = false;
    deviceId = '';
    created() {
        // this.getgroupTree(); // 设备组列表
        this.getTree();
    }
    mounted() {
        const query = this.$route.query;
        const { deviceId } = query;
        // this.getOtaDetail();
        this.deviceId = deviceId;
        if (this.deviceId) {
            this.getDeviceDetail(deviceId);
        }
    }
    getDeviceDetail(deviceId) {
        getDeviceDetail(deviceId).then((res) => {
            this.detailList = res.data.data;
            this.groupIdvalue = res.data.data.groupName;
            this.groupId = res.data.data.groupId;
            this.deviceName = this.detailList.deviceName;
            this.position = this.detailList.position;
        }).catch((err) => {
            this.$message({ message: err, type: 'error' });
            this.deviceError = true;
        });
    }
    handleRenderContent(h, { node, data, store }) {
        if (data.level !== 0) {
            return (<div class="content-left-item" style="width:100%">
          <div class={{ 'item-active': data.id === this.currIndex }} onDblclick={($e) => this.handleOndbclick($e, data)}>
            {data.name}
          </div>
        </div>);
        }
    }
    handleDragStart(node, $event) {
        this.$refs.tree.setCurrentKey(node.data.id);
        $event.dataTransfer.setData('drag', JSON.stringify(node.data));
    }
    handleNodeClick(node) {
        // this.currIndex = node.id;
        // this.parentId = node.parentId;
    }
    handleDrag(node) {
        if (node.childNodes.length === 0) {
            return true;
        }
        return false;
    }
    handleOndbclick(event, data) {
        this.groupIdvalue = data.name;
        this.groupId = data.id;
        this.$refs.deviceOrganisation.handleClose();
    }
    putDeviceDetail() {
        let data = {
            deviceId: this.deviceId,
            groupId: this.groupId,
            name: this.deviceName,
            position: this.position,
        };
        putDeviceDetail(this.deviceId, data).then((res) => {
            this.$message({ message: res.data.message, type: 'success' });
        }).catch((err) => {
            this.$message({ message: err, type: 'error' });
        });
    }
    handelBaseEdit() {
        this.canWrite = false;
    }
    handelBaseSubmit() {
        this.canWrite = true;
        this.putDeviceDetail();
    }
    handelCancel() {
        this.groupIdvalue = this.detailList.groupName;
        this.groupId = this.detailList.groupId;
        this.deviceName = this.detailList.deviceName;
        this.position = this.detailList.position;
        this.canWrite = true;
    }
    getTree() {
        let data = { keyword: '' };
        getDevicegroupsTree(data).then((res) => {
            if (res.data.data) {
                this.groupTree = res.data.data.tree;
            }
            else {
                this.groupTree = [];
            }
        });
    }
    handelOperate() {
        this.$alert(this.$t('operateConfirm').toString(), {
            confirmButtonText: this.$t('common.confirm').toString(),
            cancelButtonText: this.$t('common.cancel').toString(),
            callback: (action) => {
                if (action === 'confirm') {
                    deviceSwitch({ deviceId: this.deviceId }).then((res) => {
                        this.$message({ message: res.data.message, type: 'success' });
                    }).catch((err) => {
                        this.$message({ message: err, type: 'error' });
                    });
                }
                ;
            },
        });
    }
};
default_1 = __decorate([
    Component({
        components: { AuthItem },
        i18n: {
            messages: {
                'en-us': {
                    operateConfirm: 'Are you sure you want to manually switch the device?',
                    pleaseInput: 'Please input',
                    deviceError: 'Device error',
                },
                zh: {
                    operateConfirm: '确定要手动开合该设备吗?',
                    pleaseInput: '请输入内容',
                    deviceError: '设备异常',
                },
            },
        },
    })
], default_1);
export default default_1;
